var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "el-dialog",
        {
          staticClass: "__pop-nutritional",
          attrs: {
            title: "证书门槛设置",
            width: "1050px",
            top: "10vh",
            center: true,
            visible: _vm.isShow,
            "append-to-body": true,
          },
          on: {
            close: _vm.closePop,
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "证书设置表单",
              staticClass: "form-box",
              attrs: {
                inline: true,
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "180px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "niceConsumeFee",
                            label: "用户累计消费达标金额：",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "220px" },
                            attrs: {
                              placeholder: "请输入用户累计消费达标金额",
                              maxlength: "20",
                            },
                            model: {
                              value: _vm.formData.niceConsumeFee,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "niceConsumeFee", $$v)
                              },
                              expression: "formData.niceConsumeFee",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "consumeFeeContent",
                            label: "累计消费的富文本：",
                          },
                        },
                        [
                          _c("Tinymce", {
                            model: {
                              value: _vm.formData.consumeFeeContent,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "consumeFeeContent", $$v)
                              },
                              expression: "formData.consumeFeeContent",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-box",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn-item cancel-btn",
                  on: { click: _vm.closePop },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-item sure-btn",
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("确定")]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }